/*! Digital Ummah — comprehensive Islamic calendar (Islamic dates, Malaysian public & school
   holidays) and flip-card 99 Names. Overrides duBuildCalendar / duRender99 from the page. */
(function () {
  "use strict";
  var LS_GRP = "dxu-cal-grp", LS_F = "dxu-cal-filter";
  function lang() { return window.duLang === 1 ? 1 : 0; }
  function T(en, ms) { return lang() === 1 ? ms : en; }
  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; }); }
  function ymd(d) { return d.getFullYear() + "-" + ("0" + (d.getMonth() + 1)).slice(-2) + "-" + ("0" + d.getDate()).slice(-2); }
  function uq(d) { try { return window.duCalHijri ? window.duCalHijri(d) : null; } catch (e) { return null; } }
  // Malaysia (JAKIM/rukyah) can differ from Umm al-Qura by a day: learn the offset per Hijri month
  // from the official holiday dates, so the calendar's Hijri days match Malaysian dates.
  var OFFS = null, ANCH = { hijra: [1, 1], maulid: [3, 12], isra: [7, 27], ramadan: [9, 1], nuzul: [9, 17], fitr: [10, 1], adha: [12, 10] };
  function offsets() {
    if (OFFS) return OFFS;
    OFFS = {};
    Object.keys(PH).forEach(function (yy) {
      PH[yy].forEach(function (r) {
        var a = ANCH[r[5]]; if (!a) return;
        var d = new Date(r[0] + "T12:00:00");
        for (var off = -2; off <= 2; off++) {
          var h = uq(new Date(d.getTime() - off * 864e5));
          if (h && h.month === a[0] && h.day === a[1]) { OFFS[h.year + "-" + h.month] = off; break; }
        }
      });
    });
    return OFFS;
  }
  var hCache = {};
  function hijri(d) {
    var k = d.getFullYear() + "-" + d.getMonth() + "-" + d.getDate();
    if (k in hCache) return hCache[k];
    var o = offsets(), out = null, base = new Date(d.getFullYear(), d.getMonth(), d.getDate(), 12);
    [1, 0, 2, -1].some(function (off) {
      var h = uq(new Date(base.getTime() - off * 864e5));
      if (h && o[h.year + "-" + h.month] === off) { out = h; return true; }
      return false;
    });
    if (!out) {
      var h0 = uq(base);
      // a month with a known offset must not leak into the neighbouring month
      out = h0 && o[h0.year + "-" + h0.month] ? uq(new Date(base.getTime() - o[h0.year + "-" + h0.month] * 864e5)) : h0;
    }
    return (hCache[k] = out);
  }
  function grp() { try { return localStorage.getItem(LS_GRP) === "A" ? "A" : "B"; } catch (e) { return "B"; } }
  function filters() {
    var f = { i: 1, p: 1, s: 1 };
    try { var v = JSON.parse(localStorage.getItem(LS_F) || "null"); if (v) f = v; } catch (e) {}
    return f;
  }

  /* ------------------------------------------------ data
     Public holidays (national + main state ones) and KPM school calendar.
     Sources: cutisekolah.com.my, publicholidays.com.my, officeholidays.com (Oct 2026). */
  var PH = {
    "2026": [
      ["2026-01-01", "New Year's Day", "Tahun Baru", "Most states", "Kebanyakan negeri"],
      ["2026-01-17", "Israk & Mikraj", "Israk & Mikraj", "Kedah, N. Sembilan, Perlis, Terengganu", "Kedah, N. Sembilan, Perlis, Terengganu", "isra"],
      ["2026-02-01", "Thaipusam", "Thaipusam", "Selected states", "Negeri tertentu"],
      ["2026-02-17", "Chinese New Year", "Tahun Baru Cina", ""],
      ["2026-02-18", "Chinese New Year (Day 2)", "Tahun Baru Cina (Hari ke-2)", "Most states", "Kebanyakan negeri"],
      ["2026-02-19", "Beginning of Ramadan", "Awal Ramadan", "Johor, Kedah, Melaka", "Johor, Kedah, Melaka", "ramadan"],
      ["2026-03-07", "Nuzul al-Quran", "Nuzul Al-Quran", "Selected states", "Negeri tertentu", "nuzul"],
      ["2026-03-21", "Hari Raya Aidilfitri", "Hari Raya Aidilfitri", "", "", "fitr"],
      ["2026-03-22", "Hari Raya Aidilfitri (Day 2)", "Hari Raya Aidilfitri (Hari ke-2)", "", "", "fitr2"],
      ["2026-05-01", "Labour Day", "Hari Pekerja", ""],
      ["2026-05-27", "Hari Raya Aidiladha", "Hari Raya Aidiladha", "", "", "adha"],
      ["2026-05-28", "Hari Raya Aidiladha (Day 2)", "Hari Raya Aidiladha (Hari ke-2)", "Kedah, Kelantan, Perlis, Terengganu", "Kedah, Kelantan, Perlis, Terengganu"],
      ["2026-05-31", "Wesak Day", "Hari Wesak", ""],
      ["2026-06-01", "Agong's Birthday", "Hari Keputeraan YDP Agong", ""],
      ["2026-06-17", "Awal Muharram (Maal Hijrah)", "Awal Muharram (Maal Hijrah)", "", "", "hijra"],
      ["2026-08-25", "Maulidur Rasul", "Maulidur Rasul", "", "", "maulid"],
      ["2026-08-31", "National Day (Merdeka)", "Hari Kebangsaan", ""],
      ["2026-09-16", "Malaysia Day", "Hari Malaysia", ""],
      ["2026-11-08", "Deepavali", "Deepavali", "All except Sarawak", "Semua kecuali Sarawak"],
      ["2026-12-25", "Christmas", "Hari Krismas", ""]
    ],
    "2027": [
      ["2027-01-01", "New Year's Day", "Tahun Baru", "Most states", "Kebanyakan negeri"],
      ["2027-01-06", "Israk & Mikraj", "Israk & Mikraj", "Kedah, N. Sembilan, Perlis, Terengganu", "Kedah, N. Sembilan, Perlis, Terengganu", "isra"],
      ["2027-01-22", "Thaipusam", "Thaipusam", "Selected states", "Negeri tertentu"],
      ["2027-02-06", "Chinese New Year", "Tahun Baru Cina", ""],
      ["2027-02-07", "Chinese New Year (Day 2)", "Tahun Baru Cina (Hari ke-2)", ""],
      ["2027-02-08", "Beginning of Ramadan", "Awal Ramadan", "Johor, Kedah", "Johor, Kedah", "ramadan"],
      ["2027-02-24", "Nuzul al-Quran", "Nuzul Al-Quran", "Selected states", "Negeri tertentu", "nuzul"],
      ["2027-03-10", "Hari Raya Aidilfitri", "Hari Raya Aidilfitri", "", "", "fitr"],
      ["2027-03-11", "Hari Raya Aidilfitri (Day 2)", "Hari Raya Aidilfitri (Hari ke-2)", "", "", "fitr2"],
      ["2027-05-01", "Labour Day", "Hari Pekerja", ""],
      ["2027-05-17", "Hari Raya Aidiladha", "Hari Raya Aidiladha", "", "", "adha"],
      ["2027-05-20", "Wesak Day", "Hari Wesak", ""],
      ["2027-06-06", "Awal Muharram (Maal Hijrah)", "Awal Muharram (Maal Hijrah)", "", "", "hijra"],
      ["2027-06-07", "Agong's Birthday", "Hari Keputeraan YDP Agong", ""],
      ["2027-08-15", "Maulidur Rasul", "Maulidur Rasul", "", "", "maulid"],
      ["2027-08-31", "National Day (Merdeka)", "Hari Kebangsaan", ""],
      ["2027-09-16", "Malaysia Day", "Hari Malaysia", ""],
      ["2027-10-29", "Deepavali", "Deepavali", "All except Sarawak", "Semua kecuali Sarawak"],
      ["2027-12-25", "Christmas", "Hari Krismas", ""]
    ]
  };
  // school holidays: [start, end, en, ms]
  var SCH = {
    A: [
      ["2026-02-15", "2026-02-19", "Chinese New Year school break", "Cuti perayaan Tahun Baru Cina"],
      ["2026-03-19", "2026-03-28", "Aidilfitri & Term 1 break", "Cuti Aidilfitri & Cuti Penggal 1"],
      ["2026-05-22", "2026-06-06", "Mid-year school holidays", "Cuti Pertengahan Tahun"],
      ["2026-08-28", "2026-09-05", "Term 2 break", "Cuti Penggal 2"],
      ["2026-11-08", "2026-11-09", "Deepavali school break", "Cuti perayaan Deepavali"],
      ["2026-12-04", "2027-01-02", "Year-end school holidays", "Cuti Akhir Persekolahan"],
      ["2027-02-06", "2027-02-07", "Chinese New Year school break", "Cuti perayaan Tahun Baru Cina"],
      ["2027-03-10", "2027-03-11", "Aidilfitri school break", "Cuti perayaan Aidilfitri"]
    ],
    B: [
      ["2026-02-16", "2026-02-20", "Chinese New Year school break", "Cuti perayaan Tahun Baru Cina"],
      ["2026-03-19", "2026-03-29", "Aidilfitri & Term 1 break", "Cuti Aidilfitri & Cuti Penggal 1"],
      ["2026-05-23", "2026-06-07", "Mid-year school holidays", "Cuti Pertengahan Tahun"],
      ["2026-08-29", "2026-09-06", "Term 2 break", "Cuti Penggal 2"],
      ["2026-11-08", "2026-11-10", "Deepavali school break", "Cuti perayaan Deepavali"],
      ["2026-12-05", "2027-01-03", "Year-end school holidays", "Cuti Akhir Persekolahan"],
      ["2027-02-06", "2027-02-07", "Chinese New Year school break", "Cuti perayaan Tahun Baru Cina"],
      ["2027-03-10", "2027-03-11", "Aidilfitri school break", "Cuti perayaan Aidilfitri"]
    ]
  };
  var SCHOOL_START = { A: { "2026": "2026-01-11", "2027": "2027-01-03" }, B: { "2026": "2026-01-12", "2027": "2027-01-04" } };
  var SCH_KNOWN_TO = "2027-03-31"; // after this, KPM term breaks for 2027 are not announced yet

  // Islamic dates by Hijri month/day (every year). k = key that matches official holiday ids.
  var ISL = [
    [1, 1, "Islamic New Year (1 Muharram)", "Awal Muharram (Maal Hijrah)", "hijra", "Start of the new Hijri year.", "Permulaan tahun baharu Hijrah."],
    [1, 10, "Day of Ashura", "Hari Asyura", "", "Recommended fasting (with the 9th).", "Sunat berpuasa (bersama 9 Muharram)."],
    [3, 12, "Mawlid an-Nabi", "Maulidur Rasul", "maulid", "Birth of the Prophet Muhammad \uFDFA.", "Keputeraan Nabi Muhammad ﷺ."],
    [7, 1, "Start of Rajab", "Awal Rejab", "", "One of the sacred months.", "Salah satu bulan haram."],
    [7, 27, "Isra' & Mi'raj", "Israk & Mikraj", "isra", "The Night Journey and Ascension.", "Peristiwa Israk dan Mikraj."],
    [8, 15, "Nisf Sha'ban", "Nisfu Syaaban", "", "Mid-Sha'ban night.", "Malam pertengahan Syaaban."],
    [9, 1, "First day of Ramadan", "Awal Ramadan", "ramadan", "Fasting begins.", "Permulaan ibadah puasa."],
    [9, 17, "Nuzul al-Quran", "Nuzul Al-Quran", "nuzul", "Revelation of the Quran.", "Penurunan Al-Quran."],
    [9, 21, "Last 10 nights begin", "Mula 10 malam terakhir", "", "Seek Laylat al-Qadr on the odd nights.", "Carilah Lailatul Qadar pada malam ganjil."],
    [9, 27, "Laylat al-Qadr (likely)", "Lailatul Qadar (dijangka)", "", "The Night of Power.", "Malam Al-Qadar."],
    [10, 1, "Eid al-Fitr", "Hari Raya Aidilfitri", "fitr", "Celebration after Ramadan.", "Sambutan selepas Ramadan."],
    [10, 2, "Six days of Shawwal fasting (from today)", "Puasa enam Syawal (boleh bermula)", "", "Recommended fasting in Shawwal.", "Sunat berpuasa enam hari Syawal."],
    [12, 1, "Start of Dhul-Hijjah", "Awal Zulhijjah", "", "The best ten days of the year.", "Sepuluh hari terbaik dalam setahun."],
    [12, 8, "Day of Tarwiyah", "Hari Tarwiyah", "", "Hajj pilgrims head to Mina.", "Jemaah haji bergerak ke Mina."],
    [12, 9, "Day of Arafah", "Hari Arafah", "", "Recommended fasting for non-pilgrims.", "Sunat berpuasa bagi yang tidak berhaji."],
    [12, 10, "Eid al-Adha", "Hari Raya Aidiladha", "adha", "Day of Sacrifice.", "Hari korban."],
    [12, 11, "Days of Tashriq", "Hari Tasyrik", "", "11–13 Dhul-Hijjah: fasting is not allowed.", "11–13 Zulhijjah: haram berpuasa."],
    [12, 12, "Days of Tashriq", "Hari Tasyrik", "", "", ""],
    [12, 13, "Days of Tashriq", "Hari Tasyrik", "", "", ""]
  ];

  function phFor(y) { return PH[String(y)] || null; }
  function eventsForMonth(y, m) {
    var map = {}, add = function (key, ev) { (map[key] = map[key] || []).push(ev); };
    var dim = new Date(y, m + 1, 0).getDate(), official = phFor(y), offKeys = {};
    if (official) official.forEach(function (r) { if (r[5]) offKeys[r[5]] = r[0]; });
    for (var d = 1; d <= dim; d++) {
      var dt = new Date(y, m, d), key = ymd(dt), h = hijri(dt);
      if (!h) continue;
      ISL.forEach(function (e) {
        if (e[0] !== h.month || e[1] !== h.day) return;
        // official Malaysian date wins for public-holiday events
        if (e[4] && official && offKeys[e[4]]) return;
        add(key, { t: "i", en: e[2], ms: e[3], den: e[5], dms: e[6] });
      });
      if (h.day >= 13 && h.day <= 15 && h.month !== 9 && !(h.month === 12 && h.day === 13)) add(key, { t: "b", en: "Ayyam al-Bid (white days)", ms: "Ayyamul Bidh (hari putih)", den: "Recommended fasting on the 13th–15th.", dms: "Sunat berpuasa 13–15 setiap bulan Hijrah." });
    }
    // official Islamic dates also appear as Islamic events on the official day
    if (official) official.forEach(function (r) {
      var dt = new Date(r[0] + "T00:00:00");
      if (dt.getFullYear() !== y || dt.getMonth() !== m) return;
      var isl = r[5] ? ISL.filter(function (e) { return e[4] === r[5]; })[0] : null;
      add(r[0], { t: "p", isl: !!isl, en: r[1], ms: r[2], sen: r[3] || "", sms: r[4] || r[3] || "", den: isl ? isl[5] : "", dms: isl ? isl[6] : "" });
    });
    // fixed-date national holidays for years without a list
    if (!official) {
      [["01-01", "New Year's Day", "Tahun Baru"], ["05-01", "Labour Day", "Hari Pekerja"], ["08-31", "National Day (Merdeka)", "Hari Kebangsaan"], ["09-16", "Malaysia Day", "Hari Malaysia"], ["12-25", "Christmas", "Hari Krismas"]].forEach(function (f) {
        var k = y + "-" + f[0];
        if (+f[0].slice(0, 2) - 1 === m) add(k, { t: "p", en: f[1], ms: f[2], sen: "", sms: "" });
      });
      for (var d2 = 1; d2 <= dim; d2++) {
        var h2 = hijri(new Date(y, m, d2)), k2 = ymd(new Date(y, m, d2));
        if (!h2) continue;
        if ((h2.month === 10 && h2.day <= 2) || (h2.month === 12 && h2.day === 10) || (h2.month === 1 && h2.day === 1) || (h2.month === 3 && h2.day === 12))
          add(k2, { t: "p", en: T("Public holiday (expected)", "Cuti umum (dijangka)"), ms: "Cuti umum (dijangka)", sen: "", sms: "" });
      }
    }
    return map;
  }
  function schoolOn(key) {
    var list = SCH[grp()], out = null;
    list.forEach(function (r) { if (key >= r[0] && key <= r[1]) out = r; });
    return out;
  }

  /* ------------------------------------------------ calendar */
  var selKey = null, animDir = 0;
  function build() {
    var box = document.getElementById("duCal");
    if (!box) return;
    var now = new Date();
    if (window.duCalMonth < 0 || window.duCalMonth == null) { window.duCalYear = now.getFullYear(); window.duCalMonth = now.getMonth(); }
    var y = window.duCalYear, m = window.duCalMonth, L = lang(), F = filters(), G = grp();
    var GM = window.duGregMon, HM = window.duHijriMon, WK = window.duWkAbbr;
    var dim = new Date(y, m + 1, 0).getDate(), startDow = new Date(y, m, 1).getDay();
    var hF = hijri(new Date(y, m, 1)), hL = hijri(new Date(y, m, dim));
    var hlabel = hF && hL ? (hF.month === hL.month ? HM[hF.month][L] : HM[hF.month][L] + " – " + HM[hL.month][L]) + " " + hL.year + (L ? " H" : " AH") : "";
    var ev = eventsForMonth(y, m), todayKey = ymd(now);
    if (!selKey || selKey.slice(0, 7) !== ymd(new Date(y, m, 1)).slice(0, 7)) selKey = (todayKey.slice(0, 7) === ymd(new Date(y, m, 1)).slice(0, 7)) ? todayKey : null;

    var h = "<div class='dxc-head'><div class='dxc-tt'><div class='t'>" + esc(GM[m][L] + " " + y) + "</div><div class='hh'>" + esc(hlabel) + "</div></div>" +
      "<div class='dxc-nav'><button type='button' class='dxc-today' data-act='today'>" + T("Today", "Hari ini") + "</button>" +
      "<button type='button' data-act='prev' aria-label='" + T("Previous month", "Bulan sebelumnya") + "'>&#8249;</button>" +
      "<button type='button' data-act='next' aria-label='" + T("Next month", "Bulan seterusnya") + "'>&#8250;</button></div></div>";
    h += "<div class='dxc-bar'><div class='dxc-filt' role='group' aria-label='" + T("Show", "Papar") + "'>" +
      "<button type='button' data-f='i' class='fi" + (F.i ? " on" : "") + "' aria-pressed='" + !!F.i + "'><i></i>" + T("Islamic dates", "Tarikh Islam") + "</button>" +
      "<button type='button' data-f='p' class='fp" + (F.p ? " on" : "") + "' aria-pressed='" + !!F.p + "'><i></i>" + T("Public holidays", "Cuti umum") + "</button>" +
      "<button type='button' data-f='s' class='fs" + (F.s ? " on" : "") + "' aria-pressed='" + !!F.s + "'><i></i>" + T("School holidays", "Cuti sekolah") + "</button></div>" +
      "<div class='dxc-grp' role='group' aria-label='" + T("School group", "Kumpulan sekolah") + "'" + (F.s ? "" : " hidden") + "><span>" + T("School group", "Kumpulan") + "</span>" +
      "<button type='button' data-g='A' class='" + (G === "A" ? "on" : "") + "' title='Kedah, Kelantan, Terengganu'>A</button>" +
      "<button type='button' data-g='B' class='" + (G === "B" ? "on" : "") + "' title='" + T("Other states", "Negeri lain") + "'>B</button></div></div>";
    h += "<div class='dxc-gwrap" + (animDir ? (animDir > 0 ? " in-r" : " in-l") : "") + "'><div class='dxc-grid' role='grid'>";
    for (var w = 0; w < 7; w++) h += "<div class='wd" + (w === 5 ? " fri" : "") + "'>" + esc(WK[w][L]) + "</div>";
    for (var b = 0; b < startDow; b++) h += "<div class='dxc-c empty'></div>";
    var monthList = [];
    for (var d = 1; d <= dim; d++) {
      var dt = new Date(y, m, d), key = ymd(dt), hd = hijri(dt), list = ev[key] || [], sc = F.s ? schoolOn(key) : null;
      var show = list.filter(function (e) { return (e.t === "i" && F.i) || (e.t === "b" && F.i) || (e.t === "p" && (F.p || (e.isl && F.i))); });
      var cls = "dxc-c";
      if (key === todayKey) cls += " today";
      if (show.some(function (e) { return e.t === "p"; })) cls += " ph";
      if (show.some(function (e) { return e.t === "i" || e.isl; })) cls += " isl";
      if (sc) {
        cls += " sch";
        var prev = ymd(new Date(y, m, d - 1)), next = ymd(new Date(y, m, d + 1));
        if (!(prev >= sc[0] && prev <= sc[1]) || dt.getDay() === 0) cls += " sch-s";
        if (!(next >= sc[0] && next <= sc[1]) || dt.getDay() === 6) cls += " sch-e";
      }
      if (dt.getDay() === 5) cls += " fri";
      if (key === selKey) cls += " sel";
      var dots = "";
      if (show.some(function (e) { return e.t === "i" || e.isl; })) dots += "<i class='di'></i>";
      if (show.some(function (e) { return e.t === "p"; })) dots += "<i class='dp'></i>";
      if (!dots && show.some(function (e) { return e.t === "b"; })) dots += "<i class='db'></i>";
      var label = dt.getDate() + " " + GM[m][L] + (hd ? ", " + hd.day + " " + HM[hd.month][L] : "") + (show.length ? ": " + show.map(function (e) { return L ? e.ms : e.en; }).join(", ") : "");
      h += "<button type='button' class='" + cls + "' data-k='" + key + "' aria-label='" + esc(label) + "'><span class='gd'>" + d + "</span><span class='hd'>" + (hd ? hd.day : "") + "</span><span class='dots'>" + dots + "</span></button>";
      show.forEach(function (e) { if (e.t !== "b") monthList.push({ k: key, e: e, hd: hd }); else if (hd && hd.day === 13) monthList.push({ k: key, e: { t: "i", en: "Ayyam al-Bid (13\u201315 " + window.duHijriMon[hd.month][0] + ")", ms: "Ayyamul Bidh (13\u201315 " + window.duHijriMon[hd.month][1] + ")" }, hd: hd }); });
    }
    h += "</div></div>";
    // selected day details
    h += "<div class='dxc-day' aria-live='polite'>" + dayHtml(selKey, ev) + "</div>";
    // this month's events
    var schoolThisMonth = [];
    if (F.s) SCH[G].forEach(function (r) {
      var ms0 = ymd(new Date(y, m, 1)), me0 = ymd(new Date(y, m, dim));
      if (r[1] >= ms0 && r[0] <= me0) schoolThisMonth.push(r);
    });
    h += "<div class='dxc-list'><div class='lt'>" + T("This month", "Bulan ini") + "</div>";
    if (!monthList.length && !schoolThisMonth.length) h += "<div class='none'>" + T("No special dates this month.", "Tiada tarikh istimewa bulan ini.") + "</div>";
    var seen = {};
    monthList.forEach(function (x) {
      var id = x.k + (L ? x.e.ms : x.e.en);
      if (seen[id]) return;
      seen[id] = 1;
      var dd = new Date(x.k + "T00:00:00");
      h += "<button type='button' class='it t-" + x.e.t + "' data-k='" + x.k + "'><span class='dt'><b>" + dd.getDate() + "</b><small>" + esc(window.duWkFull[dd.getDay()][L].slice(0, 3)) + "</small></span>" +
        "<span class='tx'><span class='nm'>" + esc(L ? x.e.ms : x.e.en) + "</span><span class='sub'>" + esc(x.hd ? x.hd.day + " " + HM[x.hd.month][L] + " " + x.hd.year : "") + (x.e.t === "p" && (L ? x.e.sms : x.e.sen) ? " · " + esc(L ? x.e.sms : x.e.sen) : "") + "</span></span>" +
        "<span class='bd'>" + (x.e.t === "p" ? T("Holiday", "Cuti umum") : T("Islamic", "Islam")) + "</span></button>";
    });
    schoolThisMonth.forEach(function (r) {
      var a = new Date(r[0] + "T00:00:00"), z = new Date(r[1] + "T00:00:00");
      var rng = a.getDate() + " " + GM[a.getMonth()][L].slice(0, 3) + " – " + z.getDate() + " " + GM[z.getMonth()][L].slice(0, 3) + (z.getFullYear() !== a.getFullYear() ? " " + z.getFullYear() : "");
      h += "<button type='button' class='it t-s' data-k='" + (r[0] < ymd(new Date(y, m, 1)) ? ymd(new Date(y, m, 1)) : r[0]) + "'><span class='dt sch'><b>" + a.getDate() + "</b><small>" + esc(GM[a.getMonth()][L].slice(0, 3)) + "</small></span>" +
        "<span class='tx'><span class='nm'>" + esc(L ? r[3] : r[2]) + "</span><span class='sub'>" + esc(rng) + " · " + T("Group ", "Kumpulan ") + G + "</span></span><span class='bd'>" + T("School", "Sekolah") + "</span></button>";
    });
    var startK = SCHOOL_START[G][String(y)];
    if (F.s && startK && startK.slice(0, 7) === ymd(new Date(y, m, 1)).slice(0, 7)) {
      var sd = new Date(startK + "T00:00:00");
      h += "<div class='it t-s note'><span class='dt sch'><b>" + sd.getDate() + "</b><small>" + esc(GM[m][L].slice(0, 3)) + "</small></span><span class='tx'><span class='nm'>" + T("New school session begins", "Sesi persekolahan baharu bermula") + "</span><span class='sub'>" + T("Group ", "Kumpulan ") + G + "</span></span></div>";
    }
    h += "</div>";
    var foot = T("Hijri dates follow Malaysia's official (JAKIM) dates where announced, otherwise the Umm al-Qura calendar, and may differ by a day with local moon sighting.", "Tarikh Hijrah mengikut tarikh rasmi Malaysia (JAKIM) jika telah diumumkan, jika tidak mengikut kalendar Umm al-Qura, dan mungkin berbeza sehari mengikut rukyah tempatan.");
    if (F.s && ymd(new Date(y, m, 1)) > SCH_KNOWN_TO) foot += " " + T("KPM has not announced the 2027 term breaks yet; they will be added once published.", "KPM belum mengumumkan cuti penggal 2027; tarikh akan ditambah sebaik diumumkan.");
    foot += " " + T("Group A: Kedah, Kelantan, Terengganu. Group B: other states. Public holidays shown are national dates; some apply only in certain states.", "Kumpulan A: Kedah, Kelantan, Terengganu. Kumpulan B: negeri lain. Cuti umum ialah tarikh kebangsaan; sesetengahnya hanya untuk negeri tertentu.");
    h += "<div class='du-cal-leg dxc-leg'>" + esc(foot) + "</div>";
    box.innerHTML = h;
    box.classList.add("dxc");
    animDir = 0;
  }
  function dayHtml(key, ev) {
    if (!key) return "<div class='hint'>" + T("Tap a date to see its details.", "Ketik tarikh untuk melihat butiran.") + "</div>";
    var L = lang(), dt = new Date(key + "T00:00:00"), hd = hijri(dt), GM = window.duGregMon, HM = window.duHijriMon;
    var F = filters(), list = (ev[key] || []).filter(function (e) { return e.t === "p" ? (F.p || (e.isl && F.i)) : F.i; }), sc = F.s ? schoolOn(key) : null;
    var h = "<div class='dh'><div class='dd'>" + esc(window.duWkFull[dt.getDay()][L] + ", " + dt.getDate() + " " + GM[dt.getMonth()][L] + " " + dt.getFullYear()) + "</div>" +
      (hd ? "<div class='hj'>" + esc(hd.day + " " + HM[hd.month][L] + " " + hd.year + (L ? " H" : " AH")) + "</div>" : "") + "</div>";
    if (!list.length && !sc) h += "<div class='none'>" + T("No special events on this day.", "Tiada peristiwa khas pada hari ini.") + "</div>";
    list.forEach(function (e) {
      var desc = e.t === "p" ? [L ? e.dms : e.den, L ? e.sms : e.sen].filter(Boolean).join(" \u00B7 ") : (L ? e.dms : e.den);
      h += "<div class='ev t-" + e.t + "'><i></i><div><div class='nm'>" + esc(L ? e.ms : e.en) + "</div>" + (desc ? "<div class='ds'>" + esc(desc) + "</div>" : "") + "</div></div>";
    });
    if (sc) h += "<div class='ev t-s'><i></i><div><div class='nm'>" + esc(L ? sc[3] : sc[2]) + "</div><div class='ds'>" + T("School holidays · Group ", "Cuti sekolah · Kumpulan ") + grp() + "</div></div></div>";
    return h;
  }
  function nav(delta) {
    var m = window.duCalMonth + delta, y = window.duCalYear;
    if (m > 11) { m = 0; y++; }
    if (m < 0) { m = 11; y--; }
    window.duCalMonth = m; window.duCalYear = y;
    animDir = delta;
    build();
  }
  function wire() {
    var box = document.getElementById("duCal");
    if (!box || box._dxc) return;
    box._dxc = true;
    box.addEventListener("click", function (e) {
      var b = e.target.closest("button");
      if (!b || !box.contains(b)) return;
      var a = b.getAttribute("data-act");
      if (a === "prev") return nav(-1);
      if (a === "next") return nav(1);
      if (a === "today") { var n = new Date(); var dlt = (n.getFullYear() - window.duCalYear) * 12 + n.getMonth() - window.duCalMonth; window.duCalYear = n.getFullYear(); window.duCalMonth = n.getMonth(); selKey = ymd(n); animDir = dlt > 0 ? 1 : dlt < 0 ? -1 : 0; return build(); }
      var f = b.getAttribute("data-f");
      if (f) { var F = filters(); F[f] = F[f] ? 0 : 1; try { localStorage.setItem(LS_F, JSON.stringify(F)); } catch (er) {} return build(); }
      var g = b.getAttribute("data-g");
      if (g) { try { localStorage.setItem(LS_GRP, g); } catch (er) {} return build(); }
      var k = b.getAttribute("data-k");
      if (k) {
        selKey = k;
        var mk = new Date(k + "T00:00:00");
        if (mk.getMonth() !== window.duCalMonth) { window.duCalMonth = mk.getMonth(); window.duCalYear = mk.getFullYear(); }
        build();
        var sel = box.querySelector(".dxc-day");
        if (sel && b.classList.contains("it")) sel.scrollIntoView({ block: "nearest", behavior: matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth" });
      }
    });
    // swipe between months
    var sx = 0, sy = 0, st = 0;
    box.addEventListener("touchstart", function (e) { if (!e.target.closest(".dxc-grid")) return; sx = e.touches[0].clientX; sy = e.touches[0].clientY; st = Date.now(); }, { passive: true });
    box.addEventListener("touchend", function (e) {
      if (!st) return;
      var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
      if (Date.now() - st < 600 && Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy) * 1.5) nav(dx < 0 ? 1 : -1);
      st = 0;
    }, { passive: true });
  }

  /* ------------------------------------------------ 99 Names: flip cards */
  function render99() {
    var box = document.getElementById("duNames99");
    if (!box) return;
    var names = window.du99Names || [], L = lang();
    if (!names.length) return;
    var si = document.getElementById("du99Search"), q = (si && si.value || "").toLowerCase().trim(), h = "", n99 = window.du99 || {};
    names.forEach(function (n) {
      var e99 = L === 1 ? (n99[n.number] || n.english) : n.english;
      var m99 = L === 1 ? (n99[n.number] || n.english) : n.meaning;
      if (q) { var hay = (n.number + " " + n.transliteration + " " + n.english + " " + e99 + " " + n.meaning).toLowerCase(); if (hay.indexOf(q) < 0) return; }
      h += "<div class='c fl' data-n='" + n.number + "' onclick='duToggle99(this)'><div class='in'>" +
        "<div class='f'><div class='num'>" + n.number + "</div><div class='a' lang='ar' dir='rtl'>" + esc(n.arabic) + "</div><div class='tr'>" + esc(n.transliteration) + "</div><div class='tap'>" + T("Tap to reveal", "Ketik untuk maksud") + "</div></div>" +
        "<div class='b'><div class='num'>" + n.number + " · " + esc(n.transliteration) + "</div><div class='e'>" + esc(e99) + "</div><div class='m'>" + esc(m99) + "</div><div class='a2' lang='ar' dir='rtl'>" + esc(n.arabic) + "</div></div>" +
        "</div></div>";
    });
    box.innerHTML = h || "<div class='du-loading'>-</div>";
    box.classList.add("dxf");
    tools99();
  }
  function tools99() {
    var box = document.getElementById("duNames99");
    if (!box || box.previousElementSibling && box.previousElementSibling.classList && box.previousElementSibling.classList.contains("dxf-tools")) { label99(); return; }
    var t = document.createElement("div");
    t.className = "dxf-tools";
    t.innerHTML = "<button type='button' data-a='all'></button><button type='button' data-a='rand'></button>";
    box.parentNode.insertBefore(t, box);
    t.addEventListener("click", function (e) {
      var b = e.target.closest("button");
      if (!b) return;
      var cards = [].slice.call(box.querySelectorAll(".c.fl"));
      if (b.getAttribute("data-a") === "all") {
        var anyClosed = cards.some(function (c) { return !c.classList.contains("on"); });
        cards.forEach(function (c, i) { setTimeout(function () { c.classList.toggle("on", anyClosed); c.setAttribute("aria-expanded", anyClosed ? "true" : "false"); }, Math.min(i, 30) * 25); });
        b.setAttribute("data-open", anyClosed ? "1" : "0");
        label99();
      } else if (cards.length) {
        cards.forEach(function (c) { c.classList.remove("dxf-pick"); });
        var c = cards[Math.floor(Math.random() * cards.length)];
        c.scrollIntoView({ block: "center", behavior: matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth" });
        setTimeout(function () { c.classList.add("on", "dxf-pick"); c.setAttribute("aria-expanded", "true"); }, 350);
      }
    });
    label99();
  }
  function label99() {
    var t = document.querySelector(".dxf-tools");
    if (!t) return;
    var all = t.querySelector("[data-a=all]"), r = t.querySelector("[data-a=rand]");
    all.textContent = all.getAttribute("data-open") === "1" ? T("Hide all meanings", "Tutup semua") : T("Reveal all meanings", "Buka semua maksud");
    r.textContent = T("Random name", "Nama rawak");
  }


  /* ------------------------------------------------ official JAKIM prayer times for every zone */
  var JZ = [["JHR01", "Johor", "Pulau Aur dan Pulau Pemanggil"], ["JHR02", "Johor", "Johor Bahru, Kota Tinggi, Mersing, Kulai"], ["JHR03", "Johor", "Kluang, Pontian"], ["JHR04", "Johor", "Batu Pahat, Muar, Segamat, Gemas Johor, Tangkak"], ["KDH01", "Kedah", "Kota Setar, Kubang Pasu, Pokok Sena (Daerah Kecil)"], ["KDH02", "Kedah", "Kuala Muda, Yan, Pendang"], ["KDH03", "Kedah", "Padang Terap, Sik"], ["KDH04", "Kedah", "Baling"], ["KDH05", "Kedah", "Bandar Baharu, Kulim"], ["KDH06", "Kedah", "Langkawi"], ["KDH07", "Kedah", "Puncak Gunung Jerai"], ["KTN01", "Kelantan", "Bachok, Kota Bharu, Machang, Pasir Mas, Pasir Puteh, Tanah Merah, Tumpat, Kuala Krai, Mukim Chiku"], ["KTN02", "Kelantan", "Gua Musang (Daerah Galas Dan Bertam), Jeli, Jajahan Kecil Lojing"], ["MLK01", "Melaka", "SELURUH NEGERI MELAKA"], ["NGS01", "Negeri Sembilan", "Tampin, Jempol"], ["NGS02", "Negeri Sembilan", "Jelebu, Kuala Pilah, Rembau"], ["NGS03", "Negeri Sembilan", "Port Dickson, Seremban"], ["PHG01", "Pahang", "Pulau Tioman"], ["PHG02", "Pahang", "Kuantan, Pekan, Muadzam Shah"], ["PHG03", "Pahang", "Jerantut, Temerloh, Maran, Bera, Chenor, Jengka"], ["PHG04", "Pahang", "Bentong, Lipis, Raub"], ["PHG05", "Pahang", "Genting Sempah, Janda Baik, Bukit Tinggi"], ["PHG06", "Pahang", "Cameron Highlands, Genting Higlands, Bukit Fraser"], ["PHG07", "Pahang", "Zon Khas Daerah Rompin, (Mukim Rompin, Mukim Endau, Mukim Pontian)"], ["PRK01", "Perak", "Tapah, Slim River, Tanjung Malim"], ["PRK02", "Perak", "Kuala Kangsar, Sg. Siput , Ipoh, Batu Gajah, Kampar"], ["PRK03", "Perak", "Lenggong, Pengkalan Hulu, Grik"], ["PRK04", "Perak", "Temengor, Belum"], ["PRK05", "Perak", "Kg Gajah, Teluk Intan, Bagan Datuk, Seri Iskandar, Beruas, Parit, Lumut, Sitiawan, Pulau Pangkor"], ["PRK06", "Perak", "Selama, Taiping, Bagan Serai, Parit Buntar"], ["PRK07", "Perak", "Bukit Larut"], ["PLS01", "Perlis", "SELURUH NEGERI PERLIS"], ["PNG01", "Pulau Pinang", "SELURUH NEGERI PULAU PINANG"], ["SBH01", "Sabah", "Bahagian Sandakan (Timur), Bukit Garam, Semawang, Temanggong, Tambisan, Bandar Sandakan, Sukau"], ["SBH02", "Sabah", "Beluran, Telupid, Pinangah, Terusan, Kuamut, Bahagian Sandakan (Barat)"], ["SBH03", "Sabah", "Lahad Datu, Silabukan, Kunak, Sahabat, Semporna, Tungku, Bahagian Tawau (Timur)"], ["SBH04", "Sabah", "Bandar Tawau, Balong, Merotai, Kalabakan, Bahagian Tawau (Barat)"], ["SBH05", "Sabah", "Kudat, Kota Marudu, Pitas, Pulau Banggi, Bahagian Kudat"], ["SBH06", "Sabah", "Gunung Kinabalu"], ["SBH07", "Sabah", "Kota Kinabalu, Ranau, Kota Belud, Tuaran, Penampang, Papar, Putatan, Bahagian Pantai Barat"], ["SBH08", "Sabah", "Pensiangan, Keningau, Tambunan, Nabawan, Bahagian Pendalaman (Atas)"], ["SBH09", "Sabah", "Beaufort, Kuala Penyu, Sipitang, Tenom, Long Pasia, Membakut, Weston, Bahagian Pendalaman (Bawah)"], ["SWK01", "Sarawak", "Limbang, Lawas, Sundar, Trusan"], ["SWK02", "Sarawak", "Miri, Niah, Bekenu, Sibuti, Marudi"], ["SWK03", "Sarawak", "Pandan, Belaga, Suai, Tatau, Sebauh, Bintulu"], ["SWK04", "Sarawak", "Sibu, Mukah, Dalat, Song, Igan, Oya, Balingian, Kanowit, Kapit"], ["SWK05", "Sarawak", "Sarikei, Matu, Julau, Rajang, Daro, Bintangor, Belawai"], ["SWK06", "Sarawak", "Lubok Antu, Sri Aman, Roban, Debak, Kabong, Lingga, Engkelili, Betong, Spaoh, Pusa, Saratok"], ["SWK07", "Sarawak", "Serian, Simunjan, Samarahan, Sebuyau, Meludam"], ["SWK08", "Sarawak", "Kuching, Bau, Lundu, Sematan"], ["SWK09", "Sarawak", "Zon Khas (Kampung Patarikan)"], ["SGR01", "Selangor", "Gombak, Petaling, Sepang, Hulu Langat, Hulu Selangor, Shah Alam"], ["SGR02", "Selangor", "Kuala Selangor, Sabak Bernam"], ["SGR03", "Selangor", "Klang, Kuala Langat"], ["TRG01", "Terengganu", "Kuala Terengganu, Marang, Kuala Nerus"], ["TRG02", "Terengganu", "Besut, Setiu"], ["TRG03", "Terengganu", "Hulu Terengganu"], ["TRG04", "Terengganu", "Dungun, Kemaman"], ["WLY01", "Wilayah Persekutuan", "Kuala Lumpur, Putrajaya"], ["WLY02", "Wilayah Persekutuan", "Labuan"]];
  var ZC_KEY = "dxu-jz-cache-v1", ZSEL = "dxu-jzone";
  function zCache() { try { return JSON.parse(localStorage.getItem(ZC_KEY) || "{}") || {}; } catch (e) { return {}; } }
  function zMonth(zone) {
    var n = new Date(), mk = zone + ":" + n.getFullYear() + "-" + (n.getMonth() + 1), c = zCache();
    if (c[mk]) return Promise.resolve(c[mk]);
    return fetch("https://api.waktusolat.app/v2/solat/" + zone).then(function (r) { if (!r.ok) throw new Error("http " + r.status); return r.json(); }).then(function (j) {
      if (!j || !j.prayers || !j.prayers.length) throw new Error("empty");
      var cc = zCache(); Object.keys(cc).forEach(function (k) { if (k.split(":")[1] !== mk.split(":")[1]) delete cc[k]; });
      cc[mk] = j.prayers; try { localStorage.setItem(ZC_KEY, JSON.stringify(cc)); } catch (e) {}
      return j.prayers;
    });
  }
  function zInfo(code) { return JZ.filter(function (z) { return z[0] === code; })[0] || null; }
  function hm(ts) { var d = new Date(ts * 1000); return d.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit", hour12: false, timeZone: "Asia/Kuala_Lumpur" }); }
  function renderZone(code) {
    var out = document.getElementById("duPrayerOut"), z = zInfo(code);
    if (!out || !z) return;
    var cached = zCache()[code + ":" + new Date().getFullYear() + "-" + (new Date().getMonth() + 1)];
    if (!cached) out.innerHTML = "<div class='du-place'>" + (window.duTxt ? window.duTxt("loading") : "") + "</div>";
    zMonth(code).then(function (rows) {
      var today = new Date(), row = rows.filter(function (r) { return r.day === today.getDate(); })[0];
      if (!row) throw new Error("no day");
      var map = { imsak: row.imsak, fajr: row.fajr, sunrise: row.syuruk, dhuhr: row.dhuhr, asr: row.asr, maghrib: row.maghrib, isha: row.isha };
      var dt = {}; Object.keys(map).forEach(function (k) { dt[k] = new Date(map[k] * 1000).toISOString(); });
      window.duPrayerDT = dt;
      var now = Date.now() / 1000, nx = "";
      ["fajr", "dhuhr", "asr", "maghrib", "isha"].some(function (k) { if (map[k] > now) { nx = k; return true; } return false; });
      var L = lang(), names = window.duPrayerNames || {};
      var h = "<div class=du-next><div><div class=nl>" + window.duTxt("nextPrayer") + "</div><div class=np id=duNextLbl>-</div></div><div class=nc id=duCountdown>--:--:--</div></div>";
      h += "<div class=du-place><b>" + esc(z[2]) + "</b> (" + esc(z[1]) + ")<br>" + window.duTxt("authority") + ": <b>JAKIM (e-Solat)</b> · " + T("Zone ", "Zon ") + esc(code) + " · " + today.getDate() + "/" + (today.getMonth() + 1) + "/" + today.getFullYear() + "</div>";
      ["imsak", "fajr", "sunrise", "dhuhr", "asr", "maghrib", "isha"].forEach(function (k) {
        var isn = k === nx, nm = names[k] ? names[k][L] : k;
        h += "<div class='du-row" + (isn ? " next" : "") + "'><span class='p2'>" + esc(nm) + (isn ? " - " + window.duTxt("next") : "") + "</span><span class='t'>" + hm(map[k]) + "</span></div>";
      });
      out.innerHTML = h;
      if (typeof window.duStartCountdown === "function") window.duStartCountdown();
    }).catch(function () {
      out.innerHTML = "<div class=du-err>" + window.duTxt("failed") + "</div>";
    });
  }
  function zoneOptions(sel) {
    if (!sel) return;
    var cur = ""; try { cur = localStorage.getItem(ZSEL) || ""; } catch (e) {}
    var legacy = ""; try { legacy = localStorage.getItem("dxu-zone") || ""; } catch (e) {}
    var h = "<option value=''>" + T("Choose your area (JAKIM zone)", "Pilih kawasan anda (zon JAKIM)") + "</option>", st = "";
    JZ.slice().sort(function (a, b) { return a[1] === b[1] ? (a[0] < b[0] ? -1 : 1) : (a[1] < b[1] ? -1 : 1); }).forEach(function (z) {
      if (z[1] !== st) { if (st) h += "</optgroup>"; st = z[1]; h += "<optgroup label='" + esc(z[1]) + "'>"; }
      h += "<option value='Z:" + z[0] + "'" + (cur === z[0] ? " selected" : "") + ">" + esc(z[2]) + " (" + z[0] + ")</option>";
    });
    h += "</optgroup><optgroup label='" + T("Singapore", "Singapura") + "'><option value='sg'" + (!cur && legacy === "sg" ? " selected" : "") + ">" + T("Singapore", "Singapura") + "</option></optgroup>";
    sel.innerHTML = h;
  }
  function setupZones() {
    var sel = document.getElementById("dxuCity");
    if (!sel || sel._dxz) return !!sel;
    sel._dxz = true;
    zoneOptions(sel);
    try { new MutationObserver(function () { if (sel.options.length < 30) zoneOptions(sel); }).observe(sel, { childList: true }); } catch (e) {}
    sel.addEventListener("change", function (e) {
      var v = sel.value || "";
      if (v.indexOf("Z:") === 0) {
        e.stopImmediatePropagation();
        try { localStorage.setItem(ZSEL, v.slice(2)); localStorage.removeItem("dxu-zone"); } catch (er) {}
        renderZone(v.slice(2));
      } else { try { localStorage.removeItem(ZSEL); } catch (er) {} }
    }, true);
    // GPS: map coordinates to the official JAKIM zone when inside Malaysia
    var orig = window.duRenderPrayer;
    if (typeof orig === "function" && !orig._dxz) {
      var nr = function (lat, lng) {
        var self = this, args = arguments;
        var inMY = lat > 0.8 && lat < 7.6 && lng > 99.5 && lng < 119.5;
        var saved = ""; try { saved = localStorage.getItem(ZSEL) || ""; } catch (e) {}
        if (!inMY) return orig.apply(self, args);
        var ck = "dxu-jz-gps:" + (+lat).toFixed(2) + "," + (+lng).toFixed(2), hit = null;
        try { hit = localStorage.getItem(ck); } catch (e) {}
        (hit ? Promise.resolve({ zone: hit }) : fetch("https://api.waktusolat.app/zones/" + lat + "/" + lng).then(function (r) { return r.json(); })).then(function (j) {
          if (j && j.zone && !hit) { try { localStorage.setItem(ck, j.zone); } catch (e) {} }
          if (j && j.zone && zInfo(j.zone)) {
            try { localStorage.setItem(ZSEL, j.zone); } catch (e) {}
            var s2 = document.getElementById("dxuCity"); if (s2) s2.value = "Z:" + j.zone;
            renderZone(j.zone);
          } else if (saved) renderZone(saved); else orig.apply(self, args);
        }).catch(function () { if (saved) renderZone(saved); else orig.apply(self, args); });
      };
      nr._dxz = true;
      window.duRenderPrayer = nr;
    }
    var saved = ""; try { saved = localStorage.getItem(ZSEL) || ""; } catch (e) {}
    if (saved && zInfo(saved)) renderZone(saved);
    // language switch: refresh labels
    document.addEventListener("click", function (e) {
      if (e.target.closest && e.target.closest("#duLangEn, #duLangBm, [data-dqh-lang], .dxu-lang button")) setTimeout(function () {
        zoneOptions(document.getElementById("dxuCity"));
        var sv = ""; try { sv = localStorage.getItem(ZSEL) || ""; } catch (er) {}
        if (sv) renderZone(sv);
      }, 80);
    }, true);
    return true;
  }
  var zt = 0;
  (function waitZ() { if (!setupZones() && ++zt < 100) setTimeout(waitZ, 150); })();
  /* ------------------------------------------------ install */
  function install() {
    if (typeof window.duBuildCalendar !== "function" || typeof window.duCalHijri !== "function") return false;
    window.duBuildCalendar = build;
    window.duCalNav = nav;
    window.duRender99 = render99;
    wire();
    build();
    render99();
    // language switch → our labels too
    document.addEventListener("click", function (e) {
      if (e.target.closest && e.target.closest("#duLangEn, #duLangBm, [data-dqh-lang], .dxu-lang button")) setTimeout(function () { build(); render99(); }, 40);
    }, true);
    return true;
  }
  var tries = 0;
  (function wait() { if (!install() && ++tries < 100) setTimeout(wait, 100); })();
})();
